import ConfirmDeletePayeeModal from './ConfirmDeletePayeeModal';

export default ConfirmDeletePayeeModal;
